import gql from 'graphql-tag';

import { AI_TEXT_SIZE, type AiTextSize } from 'src/data/generation';
import { executeGqlMutation } from 'src/graphql/client';
import type { Entity, ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation UpdateBlogPostBuilderContent(
    $projectId: ID!
    $draftId: ID
    $title: String!
    $titleScore: Int
    $introParagraph: String!
    $introManualKeywords: [String!]
    $introKeywordsUsage: JSON
    $introInstructions: String
    $introGenerationLength: BlogContentGenerationLengthEnum
  ) {
    updateBlogPostBuilderContent(
      projectId: $projectId
      draftId: $draftId
      title: $title
      titleScore: $titleScore
      introParagraph: $introParagraph
      introManualKeywords: $introManualKeywords
      introKeywordsUsage: $introKeywordsUsage
      introInstructions: $introInstructions
      introGenerationLength: $introGenerationLength
    ) {
      id
    }
  }
`;

interface Params {
  projectId: ID;
  draftId?: ID;
  title: string;
  titleScore?: number;
  introParagraph: string;
  introManualKeywords?: string[];
  introKeywordsUsage?: Record<string, unknown>;
  instructions?: string;
  introGenerationLength?: AiTextSize;
}

export const updateBlogPostBuilderContent = async ({
  projectId,
  draftId,
  title,
  titleScore,
  introParagraph,
  introManualKeywords,
  introKeywordsUsage,
  instructions,
  introGenerationLength = AI_TEXT_SIZE.medium,
}: Params) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      projectId,
      draftId,
      title,
      titleScore,
      introParagraph,
      introManualKeywords,
      introKeywordsUsage: introKeywordsUsage ? JSON.stringify(introKeywordsUsage) : null,
      introInstructions: instructions,
      introGenerationLength,
    },
  });

  return getSingleProp<Entity>(result.data);
};
